"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        tableRowRoot: {
            '& td': {
                padding: "".concat(spacing(0.5), "px ").concat(spacing(), "px"),
                '&:last-child': {
                    paddingRight: spacing()
                }
            },
            '&:not(:last-child) td': {
                borderBottomWidth: 0
            }
        }
    });
});
exports.default = useStyles;
